import { Grid } from '@mui/material';
import { FC, useState } from 'react';
import { styles } from '../../styles/styles';
import { ActivityFeedSearch } from './components/activity-feed-search';

interface IProps {
  searchQuery: string;
  showTabs?: boolean;
  toggleActivityFeedContent: (value: any) => void;
  resetFilters: () => void;
  onSetSearchQuery: (query: string) => void;
}

const ActivityFeedHeader: FC<IProps> = ({ onSetSearchQuery, searchQuery, showTabs = false }) => {
  const [showSearch, setShowSearch] = useState(false);

  const onSearchOpen = () => {
    setShowSearch(true);
  };

  const onSearchClose = () => {
    setShowSearch(false);
  };

  return (
    <Grid sx={styles.header(showTabs, showSearch)}>
      <ActivityFeedSearch
        showSearch={showSearch}
        searchQuery={searchQuery}
        showTabs={showTabs}
        onSearchClose={onSearchClose}
        onSearchOpen={onSearchOpen}
        onSetSearchQuery={onSetSearchQuery}
      />
    </Grid>
  );
};

export default ActivityFeedHeader;
